import { BREAKPOINTS, useMediaQuery } from '@mc/media'

type Breakpoint = 'sm' | 'lg' | 'xl'

type MediaComponent = {
  bp: Breakpoint
  className?: string
  children: React.ReactNode
}

const getBpWidth = (bp: Breakpoint) => {
  switch (bp) {
    case 'sm':
      return BREAKPOINTS.SM
    case 'lg':
      return BREAKPOINTS.LG
    case 'xl':
      return BREAKPOINTS.XL
    default:
      return bp // type: never
  }
}

export const LessThan = ({ bp, children, className = '' }: MediaComponent) => {
  const mq = useMediaQuery(`(max-width: ${getBpWidth(bp)}px)`)
  const responsiveCls = `d-block d-${bp}-none`
  return (
    <div className={`${responsiveCls} ${className}`}>
      {mq ? children : null}
    </div>
  )
}

export const GreaterThanOrEqual = ({
  bp,
  children,
  className,
}: MediaComponent) => {
  const mq = useMediaQuery(`(min-width: ${getBpWidth(bp)}px)`)
  const responsiveCls = `d-none d-${bp}-block`
  return (
    <div className={`${responsiveCls} ${className}`}>
      {mq ? children : null}
    </div>
  )
}
